import {Anchor} from '@findhotel/sapi'

/**
 * Resolves the placeId a Hopper banner request targets: the active search's
 * placeId, or the anchor's most specific navPath id.
 */
export const getSearchPlaceId = (
  searchParameters?: {placeId?: string},
  anchor?: Partial<Anchor>
): string | undefined => {
  if (searchParameters?.placeId) return searchParameters.placeId

  if (anchor?.navPathInfo) {
    const {city, adminDivision, country} = anchor.navPathInfo

    return city?.id ?? adminDivision?.id ?? country?.id
  }

  return undefined
}
